module.exports = __webpack_public_path__ + "static/media/ic_freeehand.b23785a8.svg";